import React, {useEffect, useState} from 'react';
import Select from './Select.js';

const FormSelect = React.forwardRef(({label, value, valueLabel, setValue, error, noBottomPadding = false, placeholder = '', maxLength, options, showNone, disabled = false, popupClassName = ''}, ref) => {
	const [showSel, setShowSel] = useState(false);

	useEffect(() => {
		setShowSel(false);
	}, [value, valueLabel]);

	if (placeholder === '') {
		placeholder = label;
	}

	if (!maxLength) {
		maxLength = 100;
	}

	const showMeta = label !== '' || error !== '';

	const showSelect = () => {
		if (disabled) {
			return;
		}

		setShowSel(true);
	};

	const closeSelect = () => {
		setShowSel(false);
	};

	const returnValue = (val) => {
		setValue(val);
	};

	return (
		<>
			<div className={`input-div${error !== '' ? ' has-error' : ''}${noBottomPadding ? ' no-bottom-padding' : ''}`}>
				{showMeta ? (
					<div className="input-meta">
						<div className="input-meta-left">
							{label !== '' ? <div className="input-label">{label}</div> : ''}
						</div>
						{error !== '' ? <div className="input-error">{error}</div> : ''}
					</div>
				) : ''}
				<div className="input-control input-control--select">
					<input className={`input-text ${disabled ? 'cr_n' : 'cr_p'}`} type="text" maxLength={maxLength} placeholder={placeholder} ref={ref} value={valueLabel} onChange={(e) => setValue(e.target.value)} readOnly onClick={() => showSelect()} />
				</div>
			</div>

			<Select show={showSel} close={closeSelect} value={value} valueLabel={valueLabel} options={options} showNone={showNone} returnValue={returnValue} popupClassName={popupClassName} />
		</>
	);
});

export default FormSelect;
